export default {
  loadTimeclocks (context) {
    const query = { locked: true, $limit: 50, $sort: { location: 1 } }
    this.$feathers.service('timeclock/setup').find({ query }).then(({ data }) => {
      context.commit('setTimeclocks', data)
    })
  }
}
